import { useEffect } from "react";
import { useQuery, useSubscription, useMutation } from "@apollo/client";
import {
  QUERY_VIRTUAL_LOOPS_DATA,
  SET_VIRTUAL_LOOPS_CONFIG,
  SET_VIRTUAL_LOOPS_LAP_REAL,
  SUBSCRIBE_VIRTUAL_LOOPS_DATA,
} from "../queries/virtualLoopsQueries";

import { useDispatch } from "react-redux";
import { setVirtualLoopsData } from "../../../state/virtualLoopsReducer";

export function SetVirtualLoopsConfig() {
  const [setVirtualLoopsConfig] = useMutation(SET_VIRTUAL_LOOPS_CONFIG);
  return setVirtualLoopsConfig;
}

export function SetVirtualLoopsLapReal() {
  const [setVirtualLoopsLapReal] = useMutation(SET_VIRTUAL_LOOPS_LAP_REAL);
  return setVirtualLoopsLapReal;
}

export function QueryVirtualLoopsData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_VIRTUAL_LOOPS_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setVirtualLoopsData(data.getVirtualLoopsData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeVirtualLoopsData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_VIRTUAL_LOOPS_DATA, {
    onData: (x) => {
      const virtualLoopsUpdate = x.data.data.newVirtualLoopsData;
      dispatch(setVirtualLoopsData(virtualLoopsUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}
